import { Component, OnInit } from '@angular/core';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssetVehicleEntryService } from '../../asset-vehicle-entry/asset-vehicle-entry.service';
import { AssetVehicleApprovalService } from '../asset-vehicle-approval.service';
import { error } from 'jquery';
import { MatTableDataSource } from '@angular/material/table';
import { DialogAssetVehicleApprovalComponent } from '../dialog-asset-vehicle-approval/dialog-asset-vehicle-approval.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-asset-vehicle-approval-details',
  templateUrl: './asset-vehicle-approval-details.component.html',
  styleUrls: ['./asset-vehicle-approval-details.component.scss']
})
export class AssetVehicleApprovalDetailsComponent implements OnInit {
  displayedColumns: string[] = ['fusioncode', 'buildingName', 'minorCategoryName', 'vehicleNumber', 'approveStatus'];
  dataAvailable = true;
  campusdetails: any;
  campusId: any;
  vehicleDetails: any;
  paginator: any;
  sort: any;
  assetVehicleData: any;

  constructor(private assetvehicle: AssetVehicleApprovalService, private spinner: NgxSpinnerService, public dialog: NgDialogAnimationService,private breakpointObserver: BreakpointObserver) { }
  ngOnInit(): void {
    this.selectCampus();
  }

  selectCampus() {
    this.spinner.show();
    this.assetvehicle.getcampusdetail().subscribe(
      {
        next: (res: any) => {
          this.campusdetails = res;
          console.log('campusDetails', this.campusdetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedCampus(event: any) {
    this.campusId = event.target.value;
    console.log('campus', this.campusId);
    this.spinner.show();
    this.assetvehicle.getvehicletable(this.campusId).subscribe(
      {
        next: (res: any) => {
          this.vehicleDetails = res;
          console.log('vehicleDetails', this.vehicleDetails);
          this.assetVehicleData = new MatTableDataSource(this.vehicleDetails);
          this.assetVehicleData.sort = this.sort;
          this.assetVehicleData.paginator = this.paginator;
          this.dataAvailable = true;

          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }





  pending(row: any) {
    const dialogRef = this.dialog.open(DialogAssetVehicleApprovalComponent, {
      data: row,
      direction: 'ltr',
      height: '100%',
      panelClass: 'responsive-dialog',
      position: { right: '0px', top: '0px' },
      animation: { to: 'left' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.spinner.show();
        this.assetvehicle.getvehicletable(this.campusId).subscribe(
          {
            next: (res: any) => {
              this.vehicleDetails = res;
              console.log('vehicleDetails', this.vehicleDetails);
              this.assetVehicleData = new MatTableDataSource(this.vehicleDetails);
              this.assetVehicleData.sort = this.sort;
              this.assetVehicleData.paginator = this.paginator;
              this.dataAvailable = true;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.dataAvailable = false;
              this.spinner.hide();
            }
          }
        );
        console.log('result', result);
      }
    });
  }


  applyFilter(e: any) {

  }
}
